import { ICheckPublishRequest } from '../../../../../repositories/monolith-python/v1/check-publish';
import {
  checkBusinessCenterCategory,
  checkJKCategory,
  getJKId,
  getBusinessCenterId,
  isObjectSplits,
} from '../../../../../utils/offer';
import { ICheckoutInfoState, ICoordinates, IOfferState, EMoneySource } from '../../../../reducers';
import { getIsCalltrackingPhoneChanged } from './getIsCalltrackingPhoneChanged';
import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';

interface IGetCheckPublishParams {
  offer: IOfferState;
  locationPath: Array<number>;
  checkoutInfo: ICheckoutInfoState;
  terms: Array<ICheckPublishTermSchema>;
  isServiceChanged: boolean;
  coordinates: ICoordinates;
  moneySource: EMoneySource | null;
  extraData: object;
}

export function getCheckPublishParams(params: IGetCheckPublishParams): ICheckPublishRequest {
  const { offer, locationPath, checkoutInfo, terms, isServiceChanged, coordinates, moneySource, extraData } = params;

  const { id: objectId, category } = offer;

  const {
    autoProlongInfo: { isChecked: autoProlong },
  } = checkoutInfo;

  const isJKCategory = checkJKCategory(offer);
  const isBusinessCenterCategory = checkBusinessCenterCategory(offer);
  const newObjectId = getJKId(offer);
  const businessShoppingCenterId = getBusinessCenterId(offer);
  const isMultiListing = isObjectSplits(offer);
  const userHasChangedCalltrackingPhone = getIsCalltrackingPhoneChanged(offer);

  return {
    ...(isJKCategory && { newObjectId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    ...(objectId && { objectId }),
    ...(category && { category }),
    locationPath: locationPath.reverse().join(','),
    autoProlong,
    terms,
    latitude: coordinates.lat,
    longitude: coordinates.lng,
    isMultiListing,
    userHasChangedServices: isServiceChanged,
    userHasChangedCalltrackingPhone,
    usePromotionFromAuction: false,
    moneySource,
    extraData,
  };
}
